// Generated by ReScript, PLEASE EDIT WITH CARE

import * as Clsx from "clsx";
import * as React from "react";
import * as Caml_option from "rescript/lib/es6/caml_option.js";
import * as Core__Option from "@rescript/core/src/Core__Option.mjs";
import * as TailwindMerge from "tailwind-merge";
import * as JsxRuntime from "react/jsx-runtime";
import * as ReactToast from "@radix-ui/react-toast";

function Toast$Icon$Check(props) {
  return JsxRuntime.jsxs("svg", {
              children: [
                JsxRuntime.jsx("g", {
                      children: JsxRuntime.jsx("path", {
                            id: "Vector",
                            clipRule: "evenodd",
                            d: "M14.3388 9.47018L9.68634 14.1235C9.5296 14.2792 9.31766 14.3665 9.09676 14.3665C8.87585 14.3665 8.66391 14.2792 8.50717 14.1235L5.66051 11.2768C5.58314 11.1995 5.52176 11.1076 5.47989 11.0065C5.43802 10.9054 5.41647 10.7971 5.41647 10.6877C5.41647 10.4667 5.50425 10.2548 5.66051 10.0985C5.81676 9.94226 6.02869 9.85447 6.24967 9.85447C6.47065 9.85447 6.68258 9.94226 6.83884 10.0985L9.09634 12.356L13.1605 8.29185C13.2379 8.21448 13.3297 8.1531 13.4308 8.11123C13.5319 8.06936 13.6403 8.04781 13.7497 8.04781C13.8591 8.04781 13.9674 8.06936 14.0685 8.11123C14.1696 8.1531 14.2615 8.21448 14.3388 8.29185C14.4162 8.36922 14.4776 8.46107 14.5195 8.56216C14.5613 8.66325 14.5829 8.7716 14.5829 8.88102C14.5829 8.99043 14.5613 9.09878 14.5195 9.19987C14.4776 9.30096 14.4162 9.39281 14.3388 9.47018ZM9.99967 1.79102C4.93717 1.79102 0.833008 5.89518 0.833008 10.9577C0.833008 16.0202 4.93717 20.1243 9.99967 20.1243C15.0622 20.1243 19.1663 16.0202 19.1663 10.9577C19.1663 5.89518 15.0622 1.79102 9.99967 1.79102Z",
                            fill: "#72C040",
                            fillRule: "evenodd"
                          }),
                      id: "Basic/Solid",
                      clipPath: "url(#clip0_16844_105569)"
                    }),
                JsxRuntime.jsx("defs", {
                      children: JsxRuntime.jsx("clipPath", {
                            children: JsxRuntime.jsx("rect", {
                                  height: "20",
                                  width: "20",
                                  fill: "white",
                                  transform: "translate(0 0.957031)"
                                }),
                            id: "clip0_16844_105569"
                          })
                    })
              ],
              height: "21",
              width: "20",
              fill: "none",
              viewBox: "0 0 20 21",
              xmlns: "http://www.w3.org/2000/svg"
            });
}

var Check = {
  make: Toast$Icon$Check
};

function Toast$Icon$Warning(props) {
  var __className = props.className;
  var className = __className !== undefined ? __className : "";
  return JsxRuntime.jsx("svg", {
              children: JsxRuntime.jsx("path", {
                    clipRule: "evenodd",
                    d: "M11.4433 3.33333C10.8018 2.22222 9.19805 2.22222 8.55655 3.33333L1.33967 15.8333C0.698169 16.9444 1.50004 18.3333 2.78304 18.3333H17.2168C18.4998 18.3333 19.3017 16.9444 18.6602 15.8333L11.4433 3.33333ZM9.29286 15.7363C9.48039 15.9238 9.73475 16.0292 9.99996 16.0292C10.2652 16.0292 10.5195 15.9238 10.7071 15.7363C10.8946 15.5488 11 15.2944 11 15.0292C11 14.764 10.8946 14.5096 10.7071 14.3221C10.5195 14.1345 10.2652 14.0292 9.99996 14.0292C9.73475 14.0292 9.48039 14.1345 9.29286 14.3221C9.10532 14.5096 8.99996 14.764 8.99996 15.0292C8.99996 15.2944 9.10532 15.5488 9.29286 15.7363ZM9.41071 7.2441C9.25443 7.40038 9.16663 7.61234 9.16663 7.83335V12C9.16663 12.221 9.25443 12.433 9.41071 12.5893C9.56699 12.7456 9.77895 12.8334 9.99996 12.8334C10.221 12.8334 10.4329 12.7456 10.5892 12.5893C10.7455 12.433 10.8333 12.221 10.8333 12V7.83335C10.8333 7.61234 10.7455 7.40038 10.5892 7.2441C10.4329 7.08782 10.221 7.00002 9.99996 7.00002C9.77895 7.00002 9.56699 7.08782 9.41071 7.2441Z",
                    fill: "#EA3928",
                    fillRule: "evenodd"
                  }),
              className: className,
              height: "20",
              width: "20",
              fill: "white",
              viewBox: "0 0 20 20",
              xmlns: "http://www.w3.org/2000/svg"
            });
}

var Warning = {
  make: Toast$Icon$Warning
};

function Toast$Icon$Information(props) {
  var __className = props.className;
  var className = __className !== undefined ? __className : "";
  return JsxRuntime.jsxs("svg", {
              children: [
                JsxRuntime.jsx("g", {
                      children: JsxRuntime.jsx("path", {
                            clipRule: "evenodd",
                            d: "M9.99999 7.66666C9.73478 7.66666 9.48042 7.56131 9.29289 7.37377C9.10535 7.18623 8.99999 6.93188 8.99999 6.66667C8.99999 6.40145 9.10535 6.14709 9.29289 5.95956C9.48042 5.77202 9.73478 5.66667 9.99999 5.66667C10.2652 5.66667 10.5196 5.77202 10.7071 5.95956C10.8946 6.14709 11 6.40145 11 6.66667C11 6.93188 10.8946 7.18623 10.7071 7.37377C10.5196 7.56131 10.2652 7.66666 9.99999 7.66666ZM10.8333 13.8625C10.8333 14.0835 10.7455 14.2955 10.5892 14.4518C10.433 14.608 10.221 14.6958 9.99999 14.6958C9.77898 14.6958 9.56702 14.608 9.41074 14.4518C9.25446 14.2955 9.16666 14.0835 9.16666 13.8625V9.69583C9.16666 9.47482 9.25446 9.26286 9.41074 9.10658C9.56702 8.9503 9.77898 8.8625 9.99999 8.8625C10.221 8.8625 10.433 8.9503 10.5892 9.10658C10.7455 9.26286 10.8333 9.47482 10.8333 9.69583V13.8625ZM9.99999 0.833332C4.93749 0.833332 0.833328 4.9375 0.833328 10C0.833328 15.0625 4.93749 19.1667 9.99999 19.1667C15.0625 19.1667 19.1667 15.0625 19.1667 10C19.1667 4.9375 15.0625 0.833332 9.99999 0.833332Z",
                            fill: "white",
                            fillRule: "evenodd"
                          }),
                      clipPath: "url(#clip0_196_176)"
                    }),
                JsxRuntime.jsx("defs", {
                      children: JsxRuntime.jsx("clipPath", {
                            children: JsxRuntime.jsx("rect", {
                                  height: "20",
                                  width: "20",
                                  fill: "white"
                                }),
                            id: "clip0_196_176"
                          })
                    })
              ],
              className: className,
              height: "20",
              width: "20",
              viewBox: "0 0 20 20",
              xmlns: "http://www.w3.org/2000/svg"
            });
}

var Information = {
  make: Toast$Icon$Information
};

var Icon = {
  Check: Check,
  Warning: Warning,
  Information: Information
};

function Toast$Description$Success(props) {
  var __className = props.className;
  var className = __className !== undefined ? __className : "";
  return JsxRuntime.jsx(ReactToast.Description, {
              children: JsxRuntime.jsxs("div", {
                    children: [
                      JsxRuntime.jsx(Toast$Icon$Check, {
                            className: "w-5 h-5 bg-green-500 flex-shrink-0 "
                          }),
                      JsxRuntime.jsx("p", {
                            children: props.message,
                            className: "ml-3 break-keep  text-white"
                          })
                    ],
                    className: TailwindMerge.twMerge("px-5 py-3.5 flex rounded-2xl bg-blue-gray-900", className)
                  })
            });
}

var Success = {
  make: Toast$Description$Success
};

function Toast$Description$Warning(props) {
  var __className = props.className;
  var className = __className !== undefined ? __className : "";
  return JsxRuntime.jsx(ReactToast.Description, {
              children: JsxRuntime.jsxs("div", {
                    children: [
                      JsxRuntime.jsx(Toast$Icon$Warning, {
                            className: "w-5 h-5 text-red-500 p-px flex-shrink-0 "
                          }),
                      JsxRuntime.jsx("p", {
                            children: props.message,
                            className: "ml-3 text-white break-keep"
                          })
                    ],
                    className: TailwindMerge.twMerge("px-5 py-3.5 flex rounded-2xl bg-blue-gray-900", className)
                  })
            });
}

var Warning$1 = {
  make: Toast$Description$Warning
};

function Toast$Description$Information(props) {
  var __className = props.className;
  var className = __className !== undefined ? __className : "";
  return JsxRuntime.jsx(ReactToast.Description, {
              children: JsxRuntime.jsxs("div", {
                    children: [
                      JsxRuntime.jsx(Toast$Icon$Information, {
                            className: "w-5 h-5  rounded-full p-px flex-shrink-0 "
                          }),
                      JsxRuntime.jsx("p", {
                            children: props.message,
                            className: "ml-3 text-white break-keep"
                          })
                    ],
                    className: TailwindMerge.twMerge("px-5 py-3.5 flex rounded-2xl bg-blue-gray-900", className)
                  })
            });
}

var Information$1 = {
  make: Toast$Description$Information
};

function Toast$Description$Marketing(props) {
  return JsxRuntime.jsx(ReactToast.Description, {
              children: JsxRuntime.jsx("div", {
                    children: JsxRuntime.jsx("p", {
                          children: props.message,
                          className: "text-white font-medium text-sm whitespace-pre-wrap"
                        }),
                    className: Clsx.clsx("fixed top-[calc(100vh-12rem)] left-1/2 -translate-x-1/2 w-[288px]", "p-3 rounded-xl bg-blue-gray-800")
                  })
            });
}

var Marketing = {
  make: Toast$Description$Marketing
};

var Description = {
  Success: Success,
  Warning: Warning$1,
  Information: Information$1,
  Marketing: Marketing
};

function Toast(props) {
  var __className = props.className;
  var className = __className !== undefined ? __className : "";
  return JsxRuntime.jsx(ReactToast.Root, {
              children: props.children,
              onOpenChange: props.onOpenChange,
              className: TailwindMerge.twMerge("data-[state=open]:animate-slideIn data-[state=closed]:animate-slideOut shadow-[0px_0px_1px_0px_rgba(48,51,54,0.15)]", className),
              open: props.isOpen
            });
}

var context = React.createContext({
      publish: (function (param, param$1) {
          
        })
    });

function use() {
  return React.useContext(context);
}

var make = React.forwardRef(function (props, ref) {
      var match = React.useState(function () {
            
          });
      var setState = match[1];
      var state = match[0];
      React.useImperativeHandle(ref, (function () {
              return {
                      publish: (function (style, message) {
                          setState(function (param) {
                                return [
                                        style,
                                        message
                                      ];
                              });
                        })
                    };
            }), []);
      var tmp;
      if (state !== undefined) {
        var message = state[1];
        var tmp$1;
        switch (state[0]) {
          case "Success" :
              tmp$1 = JsxRuntime.jsx(Toast$Description$Success, {
                    message: message
                  });
              break;
          case "Warning" :
              tmp$1 = JsxRuntime.jsx(Toast$Description$Warning, {
                    message: message
                  });
              break;
          case "Info" :
              tmp$1 = JsxRuntime.jsx(Toast$Description$Information, {
                    message: message
                  });
              break;
          case "Marketing" :
              tmp$1 = JsxRuntime.jsx(Toast$Description$Marketing, {
                    message: message
                  });
              break;
          
        }
        tmp = JsxRuntime.jsx(ReactToast.Root, {
              children: JsxRuntime.jsx(ReactToast.Description, {
                    children: JsxRuntime.jsxs("div", {
                          children: [
                            tmp$1,
                            props.children
                          ],
                          className: "flex"
                        })
                  }),
              onOpenChange: (function (_val) {
                  setState(function (param) {
                        
                      });
                }),
              type: "background",
              className: TailwindMerge.twMerge("data-[state=open]:animate-slideIn  my-2 data-[state=closed]:animate-slideOut shadow-[0px_0px_1px_0px_rgba(48,51,54,0.15)]", Core__Option.getOr(props.className, "")),
              open: Core__Option.isSome(state)
            });
      } else {
        tmp = null;
      }
      return JsxRuntime.jsx(JsxRuntime.Fragment, {
                  children: Caml_option.some(tmp)
                });
    });

var ImperativeToast = {
  make: make
};

var provider = context.Provider;

function Toast$Provider(props) {
  var toastRef = React.useRef({
        publish: (function (param, param$1) {
            
          })
      });
  var element = React.createElement(provider, {
        value: {
          publish: (function (style, message) {
              toastRef.current.publish(style, message);
            })
        },
        children: props.children
      });
  return JsxRuntime.jsxs(ReactToast.Provider, {
              children: [
                element,
                JsxRuntime.jsx(make, {
                      children: JsxRuntime.jsx(JsxRuntime.Fragment, {}),
                      ref: toastRef
                    }),
                JsxRuntime.jsx(ReactToast.Viewport, {
                      className: "fixed top-22 left-1/2  z-modal-3 outline-none -translate-x-1/2"
                    })
              ],
              duration: 3000,
              swipeDirection: "up"
            });
}

var Provider = {
  ImperativeToast: ImperativeToast,
  provider: provider,
  make: Toast$Provider
};

var make$1 = Toast;

export {
  Icon ,
  Description ,
  make$1 as make,
  context ,
  use ,
  Provider ,
}
/* context Not a pure module */
